/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ImageUrl } from "../../../utils/constants";
import { GetRecurringInitiativesV2, DeleteRecurringInitiative } from "../../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { fetchApi } from "../../../utils/methods";
import dayjs from "dayjs";
import SkeletonLoder from "../../common/skeletonLoder";
import { NoData } from "../styles";
import { InitiativesWrap, InitiativeCard,Backdrop,ModalCard,ModalHeader,Divider,ModalBody,ModalActions,Button} from "../../HealthDataManagement/styles";
import { TrashIcon} from "../../../utils/icons";
import DetailPopup from "../../HealthDataManagement/initiativeParticipantsInfo";


class RecurringInitiatives extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: props.companyInfo.id,
      recurringInitiatives: [],
      loading: false,
      showDetailPopup: false,
      detailInitiative: null,
      showDeleteConfirm: false,
      deleteTarget: null,
      deleting: false
    };
  }

  componentDidMount() {
    this.getRecurringInitiatives();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedRewardPeriod?.reward_period_id !== this.props.selectedRewardPeriod?.reward_period_id) {
      this.getRecurringInitiatives();
    }
    if (prevProps.companyInfo?.id !== this.props.companyInfo?.id) {
      this.setState({ companyId: this.props.companyInfo.id }, () => {
        this.getRecurringInitiatives();
      });
    }
  }

  hideShowPopup = () => this.setState({ showDetailPopup: false, detailInitiative: null });
  showPopup = (data) => this.setState({ showDetailPopup: true, detailInitiative: data });

  getRecurringInitiatives = async () => {
    const { selectedRewardPeriod } = this.props;
    if (!selectedRewardPeriod?.reward_period_id) return;
    this.setState({ loading: true });
    const apiUrl = `${GetRecurringInitiativesV2}?company_id=${this.state.companyId}&reward_period_id=${selectedRewardPeriod.reward_period_id}`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      const months = res?.months || res?.data?.months || [];
      const initiatives = months.flatMap((m) => m.initiatives || []);
      this.setState({ recurringInitiatives: initiatives, loading: false });
    } catch (error) {
      window.console.error(error);
      this.setState({ loading: false });
    }
  };

  /** ✅ add back getMonthsCount for cards */
  getMonthsCount = (initiative) => {
    const numericCandidates = [
      initiative?.months_count,
      initiative?.month_count,
      initiative?.total_months,
      initiative?.recurring_months_count,
      initiative?.recurrence_months
    ].find((v) => typeof v === "number" && !Number.isNaN(v));

    if (typeof numericCandidates === "number") return numericCandidates;

    const stringNumeric = [
      initiative?.months_count,
      initiative?.month_count,
      initiative?.total_months,
      initiative?.recurring_months_count,
      initiative?.recurrence_months
    ].find((v) => typeof v === "string" && v.trim() !== "" && !Number.isNaN(Number(v)));

    if (stringNumeric) return Number(stringNumeric);

    if (Array.isArray(initiative?.months)) return initiative.months.length;

    if (initiative?.start_date && initiative?.end_date) {
      const start = dayjs(initiative.start_date);
      const end = dayjs(initiative.end_date);
      if (start.isValid() && end.isValid()) {
        const diff = end.startOf("month").diff(start.startOf("month"), "month") + 1;
        if (diff > 0 && diff < 1200) return diff;
      }
    }
    return null;
  };

  /** Get short month names (for delete popup) */
  getMonthsNamesShort = (initiative) => {
    const arr = [];
    if (Array.isArray(initiative?.months) && initiative.months.length > 0) {
      initiative.months.forEach((m) => {
        if (!Number.isNaN(Number(m))) arr.push(dayjs().month(Number(m) - 1).format("MMM"));
        else arr.push(String(m));
      });
    } else if (initiative?.start_date && initiative?.end_date) {
      let start = dayjs(initiative.start_date).startOf("month");
      const end = dayjs(initiative.end_date).startOf("month");
      while (start.isBefore(end) || start.isSame(end)) {
        arr.push(start.format("MMM"));
        start = start.add(1, "month");
      }
    }
    return arr.length > 0 ? arr.join(", ") : "Selected Months";
  };

  handleDeleteClick = (e, initiative) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ showDeleteConfirm: true, deleteTarget: initiative });
  };

  handleConfirmDelete = async () => {
    const { deleteTarget, companyId } = this.state;
    if (!deleteTarget) return;
    const recurringId = deleteTarget?.recurring_initiative_id ?? deleteTarget?.id;
    if (!companyId || !recurringId) {
      toast.error("Invalid initiative details to delete");
      return;
    }

    this.setState({ deleting: true });
    try {
      const url = `${DeleteRecurringInitiative}/${companyId}/${recurringId}`;
      const res = await fetchApi(url, "DELETE");
      if (res?.status === "success") {
        toast.success("Initiative deleted successfully");
        this.setState((prev) => ({
          recurringInitiatives: (prev.recurringInitiatives || []).filter((it) => {
            const itemRecurringId = it?.recurring_initiative_id ?? it?.id;
            return itemRecurringId !== recurringId;
          }),
          showDeleteConfirm: false,
          deleteTarget: null,
          deleting: false
        }));
      } else {
        toast.error(res?.error || "Failed to delete initiative");
        this.setState({ deleting: false });
      }
    } catch (err) {
      window.console.error(err);
      toast.error("Something went wrong while deleting");
      this.setState({ deleting: false });
    }
  };

  handleCancelDelete = () => {
    if (this.state.deleting) return;
    this.setState({ showDeleteConfirm: false, deleteTarget: null });
  };

  chunkArray = (arr, size) =>
    arr.reduce((acc, _, i) => (i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc), []);

  /** Delete popup */
  renderDeleteConfirmModal = () => {
    const { showDeleteConfirm, deleteTarget, deleting } = this.state;
    const { selectedYear } = this.props;
    if (!showDeleteConfirm) return null;

    const monthsNames = this.getMonthsNamesShort(deleteTarget);

    return (
      <Backdrop onClick={this.handleCancelDelete}>
        <ModalCard onClick={(e) => e.stopPropagation()}>
          <ModalHeader>
            <div>
              {`Recurring Initiative ${selectedYear}`} 
              <span className="close"  onClick={this.handleCancelDelete} aria-label="Close">×</span>
            </div>
            <div className="name">{`Recurring Initiatives for ${monthsNames}`}</div>
            
            
          </ModalHeader> 
          <Divider />
          <ModalBody>
            
            {/* <div className="name">{deleteTarget?.initiative_name || "Untitled initiative"}</div> */}
            <div style={{ marginTop: 8, color: "#184A61", textAlign: "center" }}>
              All upcoming months initiative will get deleted
            </div>
          </ModalBody>
          <Divider />
          <ModalActions>
            <Button className="danger" onClick={this.handleConfirmDelete} disabled={deleting}>
              {deleting ? "Deleting..." : "Delete"}
            </Button>
          </ModalActions>
        </ModalCard>
      </Backdrop>
    );
  };

  renderRecurringInitiatives = () => {
    const { recurringInitiatives } = this.state;
    const initiativeChunks = this.chunkArray(recurringInitiatives, 3);
    return (
      <InitiativesWrap>
        <div className="details">
          {initiativeChunks.map((chunk, chunkIndex) => (
            <React.Fragment key={chunkIndex}>
              <div className="initiative-row">
                {chunk.map((initiative) => {
                  const monthsCount = this.getMonthsCount(initiative);
                  const recurringText =
                    typeof monthsCount === "number"
                      ? `Recurring for ${monthsCount} month${monthsCount === 1 ? "" : "s"}`
                      : "Recurring";

                  return (
                    <div className="initiative-card" key={initiative.id || initiative.recurring_initiative_id}>
                      <InitiativeCard background={initiative?.color}>
                        <div className="icon">
                          <img
                            src={`${ImageUrl}/${initiative?.initiative_white_icon}`}
                            alt={initiative?.initiative_name || "initiative"}
                            onError={(e) => { e.currentTarget.src = `${ImageUrl}/default-initiative.png`; }}
                          />
                        </div>
                        <div className="wrap-content">
                          <div className="title">{initiative.initiative_name}</div>
                          <div className="completed">{recurringText}</div>
                        </div>
                        <div id="hdm-actions" className="end-container" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          {/* <span onClick={() => this.showPopup(initiative)} style={{ cursor: "pointer" }} aria-label="View details" title="View details">
                            <RecognitionEyeIconNew />
                          </span> */}
                          <span onClick={(e) => this.handleDeleteClick(e, initiative)} style={{ cursor: "pointer" }} aria-label="Delete" title="Delete">
                            {TrashIcon("#F37A65")}
                          </span>
                        </div>
                      </InitiativeCard>
                    </div>
                  );
                })}
              </div>
              {chunkIndex + 1 !== initiativeChunks?.length && <div className="border-card" />}
            </React.Fragment>
          ))}
        </div>
      </InitiativesWrap>
    );
  };

  render() {
    const { recurringInitiatives, loading, showDetailPopup, detailInitiative } = this.state;
    if (loading) {
      return (
        <div style={{ width: "385px" }}>
          <SkeletonLoder width={"1248px"} height={"500px"} />
        </div>
      );
    }
    return (
      <>
        {recurringInitiatives?.length > 0 ? this.renderRecurringInitiatives() : <NoData>No Data Found!</NoData>}
        {showDetailPopup && (
          <DetailPopup
            showModal={showDetailPopup}
            detailInitiative={detailInitiative}
            onClose={this.hideShowPopup}
            companyId={this.props.companyInfo.id}
          />
        )}
        {this.renderDeleteConfirmModal()}
      </>
    );
  }
}

RecurringInitiatives.propTypes = {
  history: PropTypes.object,
  companyId: PropTypes.any,
  companyInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
  }).isRequired,
  isHealthDash: PropTypes.bool,
  isLibrary: PropTypes.bool,
  setPage: PropTypes.func,
  role: PropTypes.string,
  selectedYearInfo: PropTypes.number,
  selectedYear: PropTypes.number,
  selectedRewardPeriod: PropTypes.shape({
    reward_period_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  })
};

export default connect(null, null)(RecurringInitiatives);